import { useEffect, useMemo, useState } from "react";
import { useRef } from "react";
import { EventElement } from "../EventItem/EventElement";

const days_week = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб']

const CalendarWeek = ({
  events_list,
  startDate,
  fetchEventData,
  setIsModal,
  setAddEvent,
  setReadOnly,
  setNewEvent,
  setEventInfo,
  dateNow,
  timeDay,
  refHeaderTop,
  selectedEvent,
  setSelectedEvent,
  setIsModalCard,
  weekHeader = { weekHeader }
}) => {
  const timeNow = new Date().getHours()
  const [positionElement, setPositionElement] = useState(0)
  const dayNow = new Date().getDate()
  const refContainer = useRef()
  const refHeader = useRef()

  const height_header = refHeaderTop?.current?.getBoundingClientRect()?.height
  const monthList = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
  const year = new Date(startDate.getTime()).getFullYear();
  const weekdayNames = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'];
  const startMonth = new Date(startDate.getTime()).getMonth();
  const endMonth = new Date(startDate.getTime() + 86400000 * 4).getMonth();
  const currentMonths = `${monthList[startMonth]} ${startMonth !== endMonth ? '- ' + monthList[endMonth] : ''} ${year}`

  // Функция для получения всей недели на основе startDate
  const getWeekDates = useMemo(() => {
    const startDateObj = new Date(startDate);
    const weekDates = [];

    // Находим понедельник недели
    const monday = new Date(startDateObj);
    const dayOfWeek = startDateObj.getDay();
    const diffToMonday = startDateObj.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
    monday.setDate(diffToMonday);

    // Генерируем все 7 дней недели
    for (let i = 0; i < 7; i++) {
      const currentDate = new Date(monday);
      currentDate.setDate(monday.getDate() + i);
      weekDates.push(currentDate.toISOString().split('T')[0]); // Формат YYYY-MM-DD
    }

    return weekDates;
  }, [startDate]);

  // Создаем дни для отображения (вся неделя)
  const weekDays = useMemo(() => {
    return getWeekDates.map(date => {
      const existingDay = events_list.find(day => day.date === date);
      return existingDay || {
        date: date,
        events: []
      };
    });
  }, [getWeekDates, events_list]);

  // Функция для группировки событий по часам для каждой даты (по аналогии с CalendarDay)
  const groupEventsByHourAndDate = useMemo(() => {
    const result = {};

    // Инициализируем структуру для каждой даты и каждого часа
    weekDays.forEach(({ date, events }) => {
      result[date] = {};

      // Группируем события для этой даты по часам
      events.forEach((event) => {
        const eventStart = new Date(event.start_time);
        const hour = eventStart.getHours();

        if (!result[date][hour]) {
          result[date][hour] = [];
        }
        result[date][hour].push({ ...event });
      });

      // Для каждого часа применяем логику группировки пересекающихся событий
      Object.keys(result[date]).forEach(hour => {
        const eventsInHour = result[date][hour];

        // Сортируем события по времени начала
        eventsInHour.sort((a, b) => new Date(a.start_time) - new Date(b.start_time));

        // Группируем пересекающиеся события
        const groups = [];
        eventsInHour.forEach(event => {
          const eventStart = new Date(event.start_time);
          const eventEnd = new Date(event.end_time);
          let placed = false;

          for (let group of groups) {
            const lastEventInGroup = group[group.length - 1];
            const lastEventEnd = new Date(lastEventInGroup.end_time);

            if (eventStart >= lastEventEnd) {
              group.push(event);
              event.groupIndex = groups.indexOf(group);
              placed = true;
              break;
            }
          }

          if (!placed) {
            groups.push([event]);
            event.groupIndex = groups.length - 1;
          }
        });

        // Сохраняем информацию о группах для каждого события
        eventsInHour.forEach(event => {
          event.totalGroups = groups.length;
        });
      });
    });

    return result;
  }, [weekDays]);

  // Скролл для элемента
  const smoothLinks = () => {
    const elements = [...document.querySelectorAll('td')];
    for (let smoothLink of elements) {
      const id = smoothLink.getAttribute('id');
      if (id && id == timeNow) {
        const element = document.querySelector(`[id="${id}"]`);

        const headerHeight = refHeaderTop?.current?.getBoundingClientRect()?.height || 0;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerHeight - 102;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
  };

  useEffect(() => {
    smoothLinks()
  }, []);

  const dateHeaders = useMemo(() => {
    return (
      <>
        {
          weekDays?.map(({ date }, ind) => {
            const day_now = new Date(date).getDate()
            const week_now = new Date(date).getDay()
            const year_now = new Date(date).getFullYear()
            const month_now = new Date(date).getMonth()

            const isStartDate =
              day_now === startDate.getDate() &&
              month_now === startDate.getMonth() &&
              year_now === startDate.getFullYear();

            const isToday =
              day_now === new Date().getDate() &&
              month_now === new Date().getMonth() &&
              year_now === new Date().getFullYear();

            const headerStyle = isStartDate ? {
              backgroundColor: 'rgb(235 245 255)',
            } : {};

            return (
              <th
                key={date}
                style={headerStyle}
                className={isToday ? 'calendar-grid__header_item-active' : 'calendar-grid__header_item'}>
                <div className='date-box'>
                  <p className='week_text'>{days_week[week_now]}</p>
                  <div className='number-box'>
                    <p className='text_number'>{day_now}</p>
                  </div>
                </div>
              </th>
            )
          })
        }
      </>
    )
  }, [weekHeader, weekDays, startDate])

  const renderedEvents = useMemo(() => {
    return (
      <>
        {
          timeDay.map((time) => {
            return (
              <tr key={time} className="row-week">
                <td className="time-box" id={time}>
                  <div className='hour-box'>
                    <p className='hour-text'>{time + ':00'}</p>
                  </div>
                </td>
                <>
                  {
                    weekDays?.map(({ date, events }, ind) => {
                      const day_now = new Date(date).getDate()
                      const month_now = new Date(date).getMonth()
                      const year_now = new Date(date).getFullYear()
                      const isStartDateCell =
                        day_now === startDate.getDate() &&
                        month_now === startDate.getMonth() &&
                        year_now === startDate.getFullYear();

                      const cellStyle = isStartDateCell ? {
                        backgroundColor: 'rgb(235 245 255)',
                      } : {};

                      // Получаем события для этого часа и даты из сгруппированных данных
                      const eventsInHour = groupEventsByHourAndDate[date]?.[time] || [];

                      return (
                        <td
                          key={`${date}-${time}`}
                          style={cellStyle}
                          className='row-week__item'
                          onClick={(e) => {
                            const date_now = new Date(date)
                            const selectDate = new Date(new Date(date_now).setHours(time, 0, 0))

                            setIsModal(true);
                            if (!e.target.closest(".event-item")) {
                              setIsModalCard(false)
                              setIsModal(true);
                              setNewEvent(true);
                              setAddEvent(true);
                              setEventInfo({
                                dateFrom: selectDate,
                                dateTo: new Date(selectDate.getTime() + 3600000),
                              });
                              setReadOnly(false);
                            }
                          }}
                        >
                          <div className="events-container" style={{ position: 'relative', height: '100%' }}>
                            {eventsInHour.map((props, index) => {
                              const { start_time, end_time, groupIndex = 0, totalGroups = 1 } = props;
                              const eventStart = new Date(start_time);
                              const eventEnd = new Date(end_time);

                              // Вычисляем высоту события
                              const startMinutes = eventStart.getMinutes();
                              const durationMinutes = (eventEnd - eventStart) / 60000;
                              const height = durationMinutes / 0.6;

                              // Вычисляем ширину и смещение в зависимости от количества групп
                              const width = totalGroups > 1 ? `${95 / totalGroups}%` : '95%';
                              const left = totalGroups > 1 ? `${(groupIndex * (95 / totalGroups)) + 2.5}%` : '2.5%';

                              return (
                                <EventElement
                                  {...props}
                                  key={props.id || JSON.stringify(props) + index}
                                  fetchEventData={(e) => fetchEventData(e)}
                                  dateFrom={eventStart}
                                  dateTo={eventEnd}
                                  setReadOnly={setReadOnly}
                                  style={{
                                    top: `${startMinutes / 0.6}%`,
                                    height: `${Math.max(30, height)}%`,
                                    width: width,
                                    left: left,
                                    zIndex: index + 1,
                                    position: 'absolute',
                                  }}
                                  selectedEvent={selectedEvent}
                                  setSelectedEvent={setSelectedEvent}
                                  setIsModalCard={setIsModalCard}
                                />
                              );
                            })}
                          </div>
                        </td>
                      );
                    })
                  }
                </>

                {dateNow.map(({ day, hours, minutes }) => {
                  if (time === hours) {
                    return (
                      <td
                        key="time-now-line"
                        className='time-now-line'
                        style={{
                          width: `${100}%`,
                          top: `${minutes / 0.6}%`,
                          left: '64px'
                        }}
                      >
                      </td>
                    );
                  }
                  return null;
                })}
              </tr>
            );
          })
        }
      </>
    );
  }, [groupEventsByHourAndDate, weekDays, startDate, timeDay, dateNow, selectedEvent]);

  const handleScroll = () => {
    const container = refContainer.current;
    if (!container) return;

    const header = refHeader.current;
    const height_header = refHeaderTop?.current?.getBoundingClientRect()?.height || 0;
    const top = container.getBoundingClientRect().top;

    if (top - height_header < 0) {
      setPositionElement(height_header - top);
    } else {
      setPositionElement(0);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className='calendar-grid'>
      <table className='table-week' ref={refContainer}>
        <thead ref={refHeader} style={{
          transform: `translateY(${positionElement}px)`,
          boxShadow: positionElement > 0 ? `0px 2px 8px 0px rgba(236, 234, 249, 0.60)` : '',
          zIndex: 1
        }}>
          <tr>
            <th className="calendar-grid__header_item_month" colSpan={8}>
              <p className="month_text">{currentMonths}</p>
            </th>
          </tr>
          <tr>
            <th className="calendar-grid__header_item"></th>
            {dateHeaders}
          </tr>
        </thead>

        <tbody className="calendar-grid__tbody">
          {renderedEvents}
        </tbody>
      </table>
    </div>
  );
};

export default CalendarWeek;